(() => {
  if (window.__ZM_GUIDELINES_BLOCK__) return;
  window.__ZM_GUIDELINES_BLOCK__ = true;

  const lockScroll = (lock) => {
    document.documentElement.style.overflow = lock ? 'hidden' : '';
  };

  document.addEventListener('click', (e) => {
    const openBtn = e.target.closest('[data-zm-open]');
    const closeBtn = e.target.closest('[data-zm-close]');
    const root = e.target.closest('[data-zm-guidelines]');

    if (openBtn && root) {
      const modal = root.querySelector('[data-zm-modal]');
      const panel = modal?.querySelector('.zm-modal__panel');
      if (!modal) return;

      modal.hidden = false;
      lockScroll(true);
      setTimeout(() => panel?.focus(), 0);
      return;
    }

    if (closeBtn) {
      const modal = e.target.closest('[data-zm-modal]');
      if (!modal) return;

      modal.hidden = true;
      lockScroll(false);
      return;
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    const modal = document.querySelector('[data-zm-modal]:not([hidden])');
    if (!modal) return;
    modal.hidden = true;
    lockScroll(false);
  });
})();
